import React from 'react';
import Icon from '@ant-design/icons';
import { IIconProps } from '@icons/IIconProps';

const TruckWIcon = (props: IIconProps) => {
    return <Icon component={svg} style={{ fontSize: 20, marginTop: 3, ...props.style }} />;
};
export default TruckWIcon;

const svg = ({ ...props }) => (
    <svg version='1.1' id='_x32_' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'  fill='currentColor' {...props}>
        <g>
            <g id='svg_1'>
                <path
                    d='m499.29,82.175l-284.771,0c-7.022,0 -12.71,6.024 -12.71,13.452l0,200.679c0,7.428 5.688,13.434 12.71,13.434l284.771,0c7.022,0 12.71,-6.005 12.71,-13.434l0,-200.679c0,-7.428 -5.688,-13.452 -12.71,-13.452z'
                    id='svg_2'
                />
                <path
                    d='m102.781,354.37c-19.705,0 -35.692,16.878 -35.692,37.723c0,20.836 15.987,37.732 35.692,37.732c19.697,0 35.665,-16.896 35.665,-37.732c0,-20.845 -15.968,-37.723 -35.665,-37.723z'
                    id='svg_3'
                />
                <path
                    d='m501.41,325.55l-303.955,0c-5.847,0 -10.599,-5.026 -10.599,-11.208l0,-167.32c0,-6.192 -4.734,-11.208 -10.599,-11.208l-96.546,0c-3.144,0 -6.12,1.483 -8.126,4.027l-69.13,87.732c-1.589,2.005 -2.455,4.549 -2.455,7.164l0,76.955l0,40.24c0,6.183 4.743,11.199 10.59,11.199l53.267,0c8.629,-12.93 22.85,-21.418 38.924,-21.418c16.066,0 30.278,8.488 38.916,21.418l217.407,0c8.629,-12.93 22.84,-21.418 38.916,-21.418c16.074,0 30.276,8.488 38.915,21.418l64.476,0c5.847,0 10.59,-5.016 10.59,-11.199l0,-15.174c-0.001,-6.191 -4.744,-11.208 -10.591,-11.208zm-462.707,-81.902l0,-7.754c0,-2.65 0.856,-5.22 2.438,-7.296l44.126,-57.463c2.085,-2.702 5.193,-4.265 8.479,-4.265l43.234,0c6.041,0 10.934,5.166 10.934,11.543l0,65.236c0,6.377 -4.894,11.544 -10.934,11.544l-87.36,0c-6.024,-0.001 -10.917,-5.168 -10.917,-11.545z'
                    id='svg_4'
                />
                <path
                    d='m398.02,354.37c-19.705,0 -35.674,16.878 -35.674,37.723c0,20.836 15.97,37.732 35.674,37.732c19.696,0 35.673,-16.896 35.673,-37.732c0,-20.845 -15.978,-37.723 -35.673,-37.723z'
                    id='svg_5'
                />
            </g>
            <text
                font-weight='bold'
                transform='matrix(13.4518 0 0 8.31297 -3462.61 -1079.31)'
                stroke='#ffffff'
                text-anchor='start'
                font-family="Roboto"
                font-size='19'
                id='svg_8'
                y='162'
                x='275'
                stroke-width='0'
                fill='#ffffff'
            >
                W
            </text>
        </g>
    </svg>
);
